import React from 'react'
import NotificationBarManagementForm from '../../features/NotificationBarManagement/NotificationBarManagementForm'

const NotificationBarManagement = () => {
    return (<NotificationBarManagementForm />)
}

export default NotificationBarManagement